var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228.39 489.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 228.39,
    height: 489.35
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -242.62,
    y1: 121.76,
    x2: 248.79,
    y2: 121.76,
    gradientTransform: "translate(80.64 83.59) rotate(20.89) scale(1.07 1.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -236.83,
    y1: 132.14,
    x2: 254.57,
    y2: 132.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -231.04,
    y1: 142.52,
    x2: 260.36,
    y2: 142.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -225.25,
    y1: 152.9,
    x2: 266.15,
    y2: 152.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -219.46,
    y1: 163.28,
    x2: 271.94,
    y2: 163.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -213.67,
    y1: 173.66,
    x2: 277.73,
    y2: 173.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -207.88,
    y1: 184.04,
    x2: 283.52,
    y2: 184.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -202.09,
    y1: 194.42,
    x2: 289.31,
    y2: 194.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -196.3,
    y1: 204.8,
    x2: 295.1,
    y2: 204.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -190.51,
    y1: 215.18,
    x2: 300.89,
    y2: 215.18,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m206.52,498.09c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06C108.64,99.79,86.47,42.58,45.47-1.09-16.31-66.89-100.44-78.07-133.75-79.83l.05-.92C-100.29-78.99-15.87-67.76,46.14-1.72c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.93-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m208.47,510.3c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-14.36-54.68-98.49-65.87-131.8-67.62l.05-.92c33.42,1.76,117.83,12.99,179.84,79.03,41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m210.42,522.5c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-12.4-42.47-96.54-53.66-129.84-55.41l.05-.92c33.42,1.76,117.83,12.99,179.84,79.03,41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m212.38,534.71c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-10.45-30.26-94.59-41.45-127.89-43.21l.05-.92c33.42,1.76,117.83,12.99,179.84,79.03,41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m214.33,546.92c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-8.5-18.06-92.63-29.24-125.94-31l.05-.92c33.42,1.76,117.83,12.99,179.84,79.03,41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m216.28,559.12c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-6.55-5.85-90.68-17.04-123.99-18.79l.05-.92C-90.52-17.95-6.11-6.72,55.9,59.32c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m218.23,571.33c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-4.59,6.36-88.73-4.83-122.03-6.59l.05-.92C-88.57-5.74-4.15,5.49,57.85,71.52c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m220.19,583.54c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-2.64,18.56-86.78,7.38-120.08,5.62l.05-.92C-86.62,6.47-2.2,17.69,59.8,83.73c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.43-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.35l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m222.14,595.75c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C-.69,30.77-84.82,19.58-118.13,17.83l.05-.92C-84.67,18.67-.25,29.9,61.76,95.94c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.42-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.34l-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m224.09,607.95c-73.13-31.6-117.15-70.94-130.83-116.93-10.49-35.23-.05-62.08,12.04-93.18,12.05-31,25.71-66.14,23.63-119.06-2.72-69.14-24.89-126.35-65.89-170.02C1.26,42.98-82.87,31.79-116.18,30.04l.05-.92C-82.71,30.88,1.7,42.11,63.71,108.15c41.16,43.84,63.42,101.24,66.14,170.61,2.09,53.1-11.61,88.34-23.7,119.42-12.03,30.94-22.41,57.65-12.02,92.58,13.61,45.72,57.45,84.86,130.32,116.34l-.36.84Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg1);
export default __webpack_public_path__ + "static/media/bg-img-1.4a1c22ac7452fa685d550a11fb8f4da4.svg";
export { ForwardRef as ReactComponent };